import React, { Component } from "react";
import Knob from "../Knob";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import socketIOClient from "socket.io-client";

import Button from "@material-ui/core/Button";

var connectionOptions = {
  "force new connection": true,
  reconnectionAttempts: "Infinity", //avoid having user reconnect manually in order to prevent dead clients after a server restart
  timeout: 10000, //before connect_error and connect_timeout are emitted.
  transports: ["websocket"]
};

const socket = socketIOClient("http://190.105.227.203/", connectionOptions);
socket.on("setBloom", bloom => console.log(bloom));
socket.on("register", bloom => console.log(bloom));

class Control extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Bloom: 1,
      Blur: 2,
      Vignette: 0,
      Distortion: 0,
      seconds: 0,
      changed: false
    };
  }

  componentDidMount = () => {
    this.interval = setInterval(() => this.tick(), 1000);
    console.log("MONTADO");
  };
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleChangeBloom = newValue => {
    this.setState({ Bloom: newValue, changed: true });
  };
  handleChangeBlur = newValue => {
    this.setState({ Blur: newValue, changed: true });
  };
  handleChangeVignette = newValue => {
    this.setState({ Vignette: newValue, changed: true });
  };
  handleChangeDistortion = newValue => {
    this.setState({ Distortion: newValue, changed: true });
  };
  handleResetExperience = () => {
    console.log("reset experience");
    socket.emit("resetExperience");
  }

  tick = () => {
    console.log("RICKT" + this.state.changed);
    if (this.state.changed) {
      console.log("emit" + this.state.Blur);
      socket.emit("updateBlur", {
        toValue: this.state.Blur
      });
      socket.emit("updateBloom", {
        toValue: this.state.Bloom / 10
      });
      socket.emit("updateVignette", {
        toValue: this.state.Vignette / 2
      });
      socket.emit("updateDistortion", {
        toValue: this.state.Distortion / 5
      });

      this.setState(prevState => ({
        seconds: prevState.seconds + 1,
        changed: false
      }));
    }
  };

  render() {
    return (
      <React.Fragment>
        <Grid
          container
          spacing={0}
          style={{ padding: "20px", textAlign: "center" }}
        >
          <Grid item xs={6}>
            <Typography variant="h5">Visión Borrosa</Typography>
            <br />
            <Knob
              value={this.state.Blur}
              onChange={this.handleChangeBlur}
              bgColor={"#cccccc"}
              fgColor={"#00e600"}
              min="0"
              max="10"
              step="0.5"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h5">Mareo</Typography>
            <br />
            <Knob
              value={this.state.Distortion}
              onChange={this.handleChangeDistortion}
              bgColor={"#cccccc"}
              fgColor={"#00e600"}
              min="0"
              max="10"
              step="0.5"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h5">Sensibilidad a la luz</Typography>
            <br />
            <Knob
              value={this.state.Bloom}
              onChange={this.handleChangeBloom}
              bgColor={"#cccccc"}
              fgColor={"#00e600"}
              mmin="0"
              max="10"
              step="0.5"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h5">Falta de Visión</Typography>
            <br />
            <Knob
              value={this.state.Vignette}
              onChange={this.handleChangeVignette}
              bgColor={"#cccccc"}
              fgColor={"#00e600"}
              min="0"
              max="10"
              step="0.5"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              style={{ margin: "0 auto" }}
              variant="contained"
              component="span"
              onClick={this.handleResetExperience}
            >
              Reiniciar Experiencia
              
            </Button>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Control;
